/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React, { useMemo } from 'react';
import { MasterFilterSheetModal } from '../filters/MasterFilterSheetModal';

export type ModalPickerOption = {
  value: string;
  label: string;
  subtitle?: string;
  disabled?: boolean;
};

type Props = {
  visible: boolean;
  title: string;
  options: ModalPickerOption[];
  selectedValue: string;
  onSelect: (value: string) => void;
  onClose: () => void;
  /** Inline create row: "＋ <createLabel>" → input inside the sheet. */
  createLabel?: string;
  createPlaceholder?: string;
  onCreateOption?: (name: string) => Promise<void>;
};

/** Ticket nested picker: paper sheet, Buscar…, flat rows + gold ✓, select closes. */
export function ModalNestedPicker({
  visible,
  title,
  options,
  selectedValue,
  onSelect,
  onClose,
  createLabel,
  createPlaceholder,
  onCreateOption,
}: Props) {
  const masterOptions = useMemo(
    () =>
      options.map((opt) => ({
        id: opt.value,
        name: opt.label,
        subtitle: opt.subtitle,
        disabled: opt.disabled,
      })),
    [options]
  );

  return (
    <MasterFilterSheetModal
      visible={visible}
      title={title}
      options={masterOptions}
      selectedId={selectedValue}
      showAllOption={false}
      appearance="ticket"
      onSelect={(id) => onSelect(id ?? '')}
      onClose={onClose}
      createLabel={createLabel}
      createPlaceholder={createPlaceholder}
      onCreateOption={onCreateOption}
    />
  );
}
